// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3eAWi","list":"BalanceDue_list__127X3","listRow":"BalanceDue_listRow__3XWqB","total":"BalanceDue_total__1GVrR"};